export default {
  initialized: false,
  item: {},
  mutation: {},
  ibans: []
};
